import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function DesktopMenu(props: {
    menuItems: { label: string; path: string }[];
}) {
    return (
        <Box sx={{ display: "flex", gap: 3, ml: 1, mr: 2, whiteSpace: "nowrap" }}>
            {props.menuItems.map((item) => (
                <Link
                    key={item.path}
                    component={RouterLink}
                    to={item.path}
                    color="inherit"
                    underline="none"
                    sx={{
                        fontWeight: 500,
                        fontSize: "1rem",
                        letterSpacing: "1px",
                        "&:hover": {
                            color: "secondary.main",
                            transition: "color 0.2s ease",
                        },
                    }}
                >
                    {item.label}
                </Link>
            ))}
        </Box>
    );
}
